import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { FieldTypesEnum } from 'constants/loanActionEditor';

import { DynamicValueInput } from '../LoanActionItems';

import { wrapperStyles } from './LoanActionUploadFormDeliveryRow.styles';

const emptyOptions = [];

const LoanActionUploadFormDeliveryRow = ({
  index,
  rootPath,
  isDisabled = false,
  isEditAllowed,
  formBundlesOptions = emptyOptions,
}) => {
  const fieldPath = `${rootPath}[${index}]`;

  return (
    <Box sx={wrapperStyles}>
      <DynamicValueInput
        required
        className="grow"
        disabled={isDisabled || !isEditAllowed}
        label="Form Bundle"
        name={`${fieldPath}.formBundle`}
        options={formBundlesOptions}
        type={FieldTypesEnum.SELECT}
      />
      <DynamicValueInput
        disabled={isDisabled || !isEditAllowed}
        label="Stop CIC"
        name={`${fieldPath}.stopCic`}
        type={FieldTypesEnum.BOOLEAN}
      />
    </Box>
  );
};

LoanActionUploadFormDeliveryRow.propTypes = {
  index: PropTypes.number.isRequired,
  rootPath: PropTypes.string.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  formBundlesOptions: PropTypes.array,
};

export default memo(LoanActionUploadFormDeliveryRow);
